const state = {
    activeDate: "",
    activeTracks: [],
    activeTypes: [],
    initialData: [],
    collapseAll: true
};
const getters = {
    availableDates: (state) => {
        const dates = state.initialData
            .map((dateObj) => {
                return {
                    date: dateObj.date,
                    formattedDate: dateObj.day
                };
            })
            .sort((a, b) => a.date.localeCompare(b.date));

        return dates;
    },
    activeSessions: (state) => {
        let data = JSON.parse(JSON.stringify(state.initialData));

        if (state.activeDate) {
            data = data.filter((dateObj) => dateObj.date == state.activeDate);
        }

        data = data.map((dateObj) => {
            if(state.activeTracks.length) {
                dateObj.items = dateObj.items.filter(
                    (item) =>
                        item.track &&
                        (item.track && state.activeTracks.includes(item.track.title))
                );
            }

            return dateObj;
        });

        data = data.map((dateObj) => {
            dateObj.items = dateObj.items.filter((item) => {
                const hasTypes = Boolean(item.types.length);
                let hasIntersection = false;

                item.types.forEach((type) => {
                    if (state.activeTypes.includes(type.id)) {
                        hasIntersection = true;
                    }
                });

                return !hasTypes || hasIntersection;
            });

            return dateObj;
        });

        data.sort((a, b) => a.date.localeCompare(b.date));

        return data;
    },
    allTracks: (state) => {
        const tracks = [];

        state.initialData.forEach((dateObj) => {
            dateObj.items.forEach((item) => {
                if (item.track) {
                    const existingTrack = tracks.find(
                        (track) => track.title == item.track.title
                    );

                    if (!existingTrack) {
                        tracks.push(item.track);
                    }
                }
            });
        });
        return tracks.sort((a, b) => {
            if(a.title < b.title) return -1;
            else if(a.title > b.title) return 1;
            return 0
        });
    },
    allTypes: (state) => {
        const types = [];

        state.initialData.forEach((dateObj) => {
            dateObj.items.forEach((item) => {
                if (item.types) {
                    item.types.forEach((type) => {
                        const existing = types.find(
                            (existingType) => existingType.id == type.id
                        );

                        if (!existing) {
                            types.push(type);
                        }
                    });
                }
            });
        });

        return types.sort((a, b) => a.title - b.title);
    },
    activeTracks: (state) => state.activeTracks
};
const mutations = {
    setInitialData: (state, value) => (state.initialData = value),
    setActiveDate: (state, value) => (state.activeDate = value),
    toggleTrack: (state, value) => {
        if (state.activeTracks.includes(value)) {
            const index = state.activeTracks.findIndex(
                (item) => item === value
            );

            state.activeTracks.splice(index, 1);
        } else {
            state.activeTracks.push(value);
        }
    },
    toggleType: (state, value) => {
        if (state.activeTypes.includes(value)) {
            const index = state.activeTypes.findIndex((item) => item === value);

            state.activeTypes.splice(index, 1);
        } else {
            state.activeTypes.push(value);
        }
    },
    setType: (state, value) => state.activeTypes.push(value),
    setTrack: (state, value) => state.activeTracks.push(value),
    clearTypes: (state) => state.activeTypes.splice(0),
    clearTracks: (state) => state.activeTracks.splice(0),
    toggleCollapseAll: (state, value) => {
        if(value != null) state.collapseAll = value
        else state.collapseAll = !state.collapseAll;
    }
};
const actions = {
    checkAllTracks: ({ getters, commit }) => {
        commit("clearTracks");
        getters.allTracks.forEach((track) => commit("setTrack", track.title));
    },
    uncheckAllTracks: ({ getters, commit }) => {
        commit("clearTracks");
    },
    resetFilters: ({ dispatch }) => {
        dispatch("uncheckAllTracks");
    }
};

export default { state, getters, mutations, actions };


// WEBPACK FOOTER //
// ./src/js/vuex-modules/agenda.js